<template>
    <div class="card col-12 mx-auto">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">
                <page-title :title="$t('sideMenu.eventSubscriptions')" :showTitle="true"></page-title>
            </div>
        </div>

        <div class="card-body">

            <event-subscriptions-grid ref="eventSubscriptionsGrid"
                                      :showHideButton="false"
                                      :showPinButton="false"
                                      :showNewButton="false"
                                      :showResizeIcon="false"
                                      :showSettingsBtn="true"
                                      :showBtns="true"
                                      :expandFirstMasterDetails="false"
                                      :hiddenColumns="['eventSubscriptionStartDate', 'eventSubscriptionEndDate']">
            </event-subscriptions-grid>
            
        </div>
    </div>
   
</template>

<script>
    import EventSubscriptionsGrid from "../../components/subscriptions/EventSubscriptionsGrid";
    import PageTitle from '../../components/common/PageTitle';
  

    export default {
        components: {
            EventSubscriptionsGrid,
            PageTitle
        },
        data () {
            return {
               
            }
        },
        methods: {
            
        }
    }
</script>

<style scoped>

</style>
